/**
 * Count template rows for preset group totals
 * For Media Devoted | Created By Ciro Autiero
 */

import type { Preset } from '../../shared';

export function presetTemplateDropCount(preset: Pick<Preset, 'presetType' | 'items'>): number {
  if (preset.presetType === 'rule-based') {
    return Math.max(1, preset.items?.length ?? 0);
  }
  return preset.items?.length ?? 0;
}

export function sumPresetTemplateDrops(presets: Pick<Preset, 'presetType' | 'items'>[]): number {
  let n = 0;
  for (const p of presets) {
    n += presetTemplateDropCount(p);
  }
  return n;
}
